// extracted by mini-css-extract-plugin
export default {"top_img":"index_top_img_BKVXQ","closed":"index_closed_HL2Bn","a_link":"index_a_link_CC0nb"};